import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SectionHeader } from '@pages/IntroducingBroker/Dashboard/components/SectionHeader/SectionHeader'
import { IBRebateApprovalsPage } from '@pages/IntroducingBroker/Rebates/Approvals/Approvals.page'
import { IBRebatesClientsPage } from '@pages/IntroducingBroker/Rebates/Clients/Clients.page'

import { Tab, Tabs } from '@ui/components/Tabs'

import { useGAEvents } from '@utils/callGAEvents'

export const RebatesManagement = () => {
  const { t } = useTranslation()
  const { callGAEvents } = useGAEvents()

  const [activeTab, setActiveTab] = useState('1')

  const tabs: Tab[] = [
    { id: '1', label: t('IB.RebatesPage.Clients') },
    {
      id: '2',
      label: t('IB.RebatesPage.Approvals'),
    },
  ]

  const renderSection = () => {
    switch (activeTab) {
      case '1':
        return <IBRebatesClientsPage isRebatesManagement />
      case '2':
        return <IBRebateApprovalsPage isRebatesManagement />
      default:
        return null
    }
  }

  const renderPath = () => {
    const path = '/dashboard/introducing-broker/rebates'

    switch (activeTab) {
      case '1':
        return path + '/clients'
      case '2':
        return path + '/approvals'
      default:
        return path
    }
  }

  return (
    <div>
      <SectionHeader
        title={t('IB.Dashboard.Rebates Management')}
        seeMoreLinkProps={{
          onClick: () => callGAEvents().IBDashboard.RebatesManagement.seeMore(),
          to: renderPath(),
        }}
        tabs={
          <Tabs
            initialIndex={tabs.findIndex((tab) => tab.id === activeTab)}
            tabs={tabs}
            onTabClick={(tab) => setActiveTab(tab.id as string)}
          />
        }
      />
      {renderSection()}
    </div>
  )
}
